import React, { Component } from "react";
import ReminderEmailManagement from "../ReminderEmailManagement";
import ReminderEmailSetting from "../ReminderEmailSetting";
import { connect } from "react-redux";
const INITIAL_STATE = {
  page: "",
};

function mapStateToProps(state) {
  return {
    pages: state.pages,
  };
}

class ReminderEmailPage extends Component {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, INITIAL_STATE);
  }

  render() {
    const { page } = this.state;
    const {pages}  = this.props;

    switch (page) {
      case "ReminderEmailManagement":
        return (
          <ReminderEmailManagement
            redirectToPage={(value) => this.setState({ page: value })}
          />
        );

      case "ReminderEmailSetting":
        return (
          <ReminderEmailSetting
            redirectToPage={(value) => this.setState({ page: value })}
          />
        );     
      default:
        return (
          <ReminderEmailManagement
            redirectToPage={(value) => this.setState({ page: value })}
          />
        );
    }
  }
}

export default connect(mapStateToProps, null)(ReminderEmailPage);
